import { render, staticRenderFns } from "./item-create-topbar.vue?vue&type=template&id=4be97fdc&"
import script from "./item-create-topbar.vue?vue&type=script&lang=ts&"
export * from "./item-create-topbar.vue?vue&type=script&lang=ts&"
import style0 from "./item-create-topbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports